export function ConsoleFooter() {
  return (
    <footer className="border-t px-6 py-3 text-center text-xs text-muted-foreground">
      © 2025 X-OR Cloud
    </footer>
  );
}
